import React, { useState } from 'react';
import {
  Box,
  Button,
  TextField,
  Typography,
  Paper,
  Alert,
  List,
  ListItem,
  ListItemText
} from '@mui/material';
import { apiClient } from '../../api/apiClient';

export default function PasswordChange() {
  const [formData, setFormData] = useState({
    old_password: '',
    new_password: '',
    confirm_password: ''
  });
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    setError(null);
    setSuccess(false);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError(null);
    setSuccess(false);

    // Überprüfe ob die Passwörter übereinstimmen
    if (formData.new_password !== formData.confirm_password) {
      setError({
        message: "Die Passwörter stimmen nicht überein",
        errors: ["Das neue Passwort und die Bestätigung müssen identisch sein"]
      });
      return;
    }

    try {
      await apiClient.post('/auth/change-password', {
        old_password: formData.old_password,
        new_password: formData.new_password
      }, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });

      setSuccess(true);
      setFormData({
        old_password: '',
        new_password: '',
        confirm_password: ''
      });
    } catch (error) {
      if (error.response?.data?.detail) {
        const detail = error.response.data.detail;
        const message = typeof detail === 'object' ? detail.message || JSON.stringify(detail) : detail;
        const errors = Array.isArray(detail) 
          ? detail.map(err => typeof err === 'object' ? JSON.stringify(err) : err)
          : [typeof detail === 'object' ? JSON.stringify(detail) : detail];
        
        setError({
          message: message,
          errors: errors
        });
      } else {
        setError({
          message: "Ein Fehler ist aufgetreten",
          errors: ["Bitte versuchen Sie es später erneut"]
        });
      }
    }
  };

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h5" sx={{ mb: 3 }}>
        Passwort ändern
      </Typography>

      <Paper sx={{ p: 3, maxWidth: 600, mx: 'auto' }}>
        {success && (
          <Alert severity="success" sx={{ mb: 3 }}>
            Ihr Passwort wurde erfolgreich geändert
          </Alert>
        )}

        {error && (
          <>
            <Alert severity="error" sx={{ mb: 2 }}>
              {typeof error.message === 'object' ? JSON.stringify(error.message) : error.message}
            </Alert>
            {error.errors && error.errors.length > 0 && (
              <List dense sx={{ mb: 2 }}>
                {error.errors.map((err, index) => (
                  <ListItem key={index}>
                    <ListItemText 
                      primary={typeof err === 'object' ? JSON.stringify(err) : err} 
                    />
                  </ListItem>
                ))}
              </List>
            )}
          </>
        )}

        <form onSubmit={handleSubmit}>
          <TextField
            name="old_password"
            label="Aktuelles Passwort"
            type="password"
            value={formData.old_password}
            onChange={handleInputChange}
            fullWidth
            required
            sx={{ mb: 2 }}
          />

          <TextField
            name="new_password"
            label="Neues Passwort"
            type="password"
            value={formData.new_password}
            onChange={handleInputChange}
            fullWidth
            required
            sx={{ mb: 2 }}
          />

          <TextField
            name="confirm_password"
            label="Neues Passwort bestätigen"
            type="password"
            value={formData.confirm_password}
            onChange={handleInputChange}
            fullWidth
            required
            sx={{ mb: 3 }}
          />

          <Button
            type="submit"
            variant="contained"
            color="primary"
            fullWidth
          >
            Passwort ändern
          </Button>
        </form>
      </Paper>
    </Box>
  );
} 